/* astkern-perso-to-cart-note.js — V6 2026-05-06
 *
 * Stellt sicher, dass JEDE Eurobox-Deckel-Position in tricoma sprechende
 * Anmerkungs-Zeilen bekommt — egal ob das Snippet seinen Mirror initialisieren
 * konnte oder nicht. Bug Order #2362 (Bestellung 7093, Pos 38290) hat gezeigt:
 * der Mirror im Snippet hängt am `productInfo.querySelector('form[action*="/cart/add"]')`
 * zur Init-Zeit — wenn das `<product-info>`-Element bei Hyper-Theme noch nicht
 * hydrated ist, läuft der Mirror nie und Gravur-Text/Font/Größe gehen verloren.
 *
 * V6-Strategie: am submit/cart:beforeAdd am Form das passende Widget global
 * suchen und Properties direkt ans Form pflanzen. Lazy-Lookup → kein
 * Hydration-Race mehr. Idempotent: wenn das Snippet seinen Mirror bereits
 * gesetzt hat, updaten wir nur die Werte (kein Doppel-Submit).
 *
 * Properties die V6 setzt:
 *   - Gravur-Typ:      'Lasergravur' | 'CNC-Gravur' | 'keine Gravur'
 *   - Gravur-Text / -Font / -Groesse  (CNC, nur wenn Text vorhanden)
 *   - Laser-Wunsch                    (Laser, nur wenn Wunsch vorhanden)
 *
 * Cart-Note-Eingabefeld bleibt versteckt (User soll nicht aus Versehen das Feld
 * benutzen — Versand-Team verlässt sich auf Position-Anmerkungen).
 *
 * ASCII-only für alle automatischen Werte: bestellungen_positionen.anmerkung
 * ist Latin-1, der tricoma-Connector encoded UTF-8 nicht → Mojibake. User-
 * Eingaben bleiben unangetastet (User-Verantwortung).
 *
 * Bewusst NICHT in V6: fetch-Override für /cart/add.js. Die Hyper-Theme-Pipeline
 * geht durch submit (capture-phase) — das hat bei V5 schon getriggert und ist
 * damit verifiziert. Ein fetch-Hook würde auch "you may also like"-Karussell-
 * ATCs treffen und Cross-Produkt-Properties einschleusen.
 */
(function () {
  if (window.__astkernPersoToNote) return;
  window.__astkernPersoToNote = true;

  // ── Cart-Note-Eingabefeld verstecken ────────────────────────────────
  var hideStyle = document.createElement('style');
  hideStyle.setAttribute('data-astkern-hide-note', '1');
  hideStyle.textContent = 'cart-note { display: none !important; }';
  (document.head || document.documentElement).appendChild(hideStyle);

  // ── Hilfsfunktionen ─────────────────────────────────────────────────
  function findActiveWidget(scope) {
    if (!scope) scope = document;
    var sels = '[data-astkern-gravur]:not([data-perso-hidden="true"]),' +
               '[data-astkern-laser]:not([data-perso-hidden="true"])';
    return scope.querySelector(sels);
  }

  function findWidgetForForm(form) {
    if (!form) return findActiveWidget(document);
    // 1) Bevorzugt: gleiche product-info / main-product Section.
    //    Das schließt Karussell-/Related-Products aus.
    var scope = (form.closest && form.closest('product-info'))
             || (form.closest && form.closest('[data-section-type="main-product"]'))
             || (form.closest && form.closest('section'));
    var w = scope ? findActiveWidget(scope) : null;
    if (w) return w;
    // 2) Fallback: globaler Lookup nur wenn es genau EIN Widget auf der Page gibt.
    //    Verhindert Cross-Produkt-Pollution wenn mehrere Widgets gerendert sind.
    var all = document.querySelectorAll(
      '[data-astkern-gravur]:not([data-perso-hidden="true"]),' +
      '[data-astkern-laser]:not([data-perso-hidden="true"])'
    );
    return all.length === 1 ? all[0] : null;
  }

  function readWidgetState(widget) {
    if (!widget) return null;
    var hidden = widget.getAttribute('data-perso-hidden') === 'true';
    if (widget.hasAttribute('data-astkern-laser')) {
      var lw = (widget.querySelector('[data-astkern-laser-wunsch]') || {}).value || '';
      // Eine hochgeladene Motiv-Datei zaehlt wie ein Wunschtext. Der File-Input
      // haengt beim Absenden schon im Kaufformular (astkern-laser-upload.liquid
      // zieht ihn dorthin), deshalb ueber die ID suchen und nicht im Widget.
      // Ohne das schrieb V6 bei "Datei ja, Anmerkung nein" Gravur-Typ
      // "keine Gravur" und leerte den Laser-Wunsch-Spiegel des Upload-Snippets
      // (#2805, 10.09.2026: Lieferung im Normal-Lager, Scanstation "keine Gravur").
      var pid = widget.getAttribute('data-product-id');
      var fileIn = (pid && document.getElementById('astkern-gravur-datei-' + pid))
                || widget.querySelector('[data-astkern-datei]');
      var fname = (fileIn && fileIn.files && fileIn.files[0]) ? fileIn.files[0].name : '';
      var loff = hidden || (!lw.trim() && !fname);
      var wunsch = lw.trim()
        ? (fname ? lw + ' (Datei: ' + fname + ')' : lw)
        : 'Motiv-Datei hochgeladen: ' + fname;
      return {
        kind: 'laser',
        props: {
          'Gravur-Typ':   loff ? 'keine Gravur' : 'Lasergravur',
          'Laser-Wunsch': loff ? '' : wunsch,
        },
      };
    }
    // CNC
    var mode = widget.getAttribute('data-mode');
    var txt  = (widget.querySelector('[data-astkern-text]')  || {}).value || '';
    var font = (widget.querySelector('[data-astkern-font]')  || {}).value || '';
    var size = (widget.querySelector('[data-astkern-size]')  || {}).value || '';
    var off  = hidden || mode === 'off' || !txt.trim();
    return {
      kind: 'cnc',
      props: {
        'Gravur-Typ':     off ? 'keine Gravur' : 'CNC-Gravur',
        'Gravur-Text':    off ? '' : txt,
        'Gravur-Font':    off ? '' : font,
        'Gravur-Groesse': off ? '' : size,
      },
    };
  }

  // ── Property in Form spiegeln (idempotent, defensiv) ────────────────
  function setOrUpdateProp(form, key, value) {
    var name = 'properties[' + key + ']';
    // Bestehender Hidden-Mirror (vom Snippet oder von uns)? → Value updaten.
    var hid = form.querySelector('input[type="hidden"][name="' + name + '"]');
    if (hid) {
      hid.value = value || '';
      return;
    }
    // User-Input mit gleichem name (Widget direkt im Form, Snippet-Mirror
    // hat Namen noch nicht gestrippt) → NICHT eingreifen. Der Browser
    // submitted den User-Wert eh; und bei Toggle 'Schlicht' setzt das
    // Snippet die Felder auf disabled, dann werden sie ohnehin nicht gesendet.
    var userInp = form.querySelector('input[name="' + name + '"], textarea[name="' + name + '"], select[name="' + name + '"]');
    if (userInp) return;
    // Sonst: frischen Hidden-Input anlegen.
    var h = (form.ownerDocument || document).createElement('input');
    h.type  = 'hidden';
    h.name  = name;
    h.value = value || '';
    h.setAttribute('data-astkern-mirror', 'v6');
    form.appendChild(h);
  }

  function syncFormFromWidget(form) {
    if (!form) return null;
    var widget = findWidgetForForm(form);
    if (!widget) return null;
    var st = readWidgetState(widget);
    if (!st) return null;
    Object.keys(st.props).forEach(function (k) {
      setOrUpdateProp(form, k, st.props[k]);
    });
    return {widget: widget, state: st};
  }

  /**
   * Pflichtfeld-Validierung: wenn der User auf "Personalisiert" stehen hat
   * (mode='on'), aber den Wunschtext nicht ausgefuellt hat, blocken wir den
   * Submit und zeigen den nativen Validity-Tooltip an der Textarea — damit
   * keine "keine Gravur"-Bestellungen mehr durchschluepfen wenn der Kunde
   * eigentlich gravieren wollte.
   *
   * Returns true wenn Submit blockiert werden soll.
   */
  function validatePersoRequired(widget) {
    if (!widget || widget.hasAttribute('data-astkern-laser')) return false;
    if (widget.getAttribute('data-mode') !== 'on') return false;
    if (widget.getAttribute('data-perso-hidden') === 'true') return false;
    var ta = widget.querySelector('[data-astkern-text]');
    if (!ta) return false;
    if (ta.value && ta.value.trim()) return false;
    // Leerer Text bei aktivem Toggle → reportValidity am DOM-Element triggert
    // den nativen Browser-Tooltip (auch wenn Element nicht im Form-Tree liegt).
    try {
      ta.setCustomValidity('Bitte deinen Gravurtext eingeben — oder oben "Ohne Gravur" wählen.');
      ta.reportValidity && ta.reportValidity();
      ta.scrollIntoView({behavior: 'smooth', block: 'center'});
      ta.focus({preventScroll: true});
      // Custom-Validity wieder zurücksetzen sobald User tippt
      var clear = function () {
        ta.setCustomValidity('');
        ta.removeEventListener('input', clear);
      };
      ta.addEventListener('input', clear);
    } catch (_) {}
    return true;
  }

  // ── Hook: klassisches Submit (capture-phase, läuft VOR Bubble-Listenern) ──
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f && f.matches && f.matches('form[action*="/cart/add"]'))) return;
    try {
      var res = syncFormFromWidget(f);
      if (res && validatePersoRequired(res.widget)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    } catch (_) {}
  }, true);

  // ── Hook: Hyper/Custom-Theme-Events vor AJAX-Submit ─────────────────
  ['cart:beforeAdd', 'cart:before-add', 'cart:adding'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var detail = e && e.detail;
      var f = (detail && (detail.form || detail.target)) || null;
      if (!(f && f.tagName === 'FORM')) return;
      try {
        var res = syncFormFromWidget(f);
        if (res && validatePersoRequired(res.widget)) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      } catch (_) {}
    }, true);
  });

  // ── Hook: Click auf ATC-Button (für Themes die formdata vor dem submit lesen
  //    oder direkt fetch/.cart-add aufrufen ohne submit-Event). Capture-phase.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[type="submit"], [name="add"], button.product-form__submit');
    if (!btn) return;
    var f = btn.closest('form[action*="/cart/add"]');
    if (!f) return;
    try {
      var res = syncFormFromWidget(f);
      if (res && validatePersoRequired(res.widget)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    } catch (_) {}
  }, true);
})();
